module.exports = __webpack_public_path__ + "8c75af4c2233140fd3aa88a50a056469.jpg";